export default {"src":"/_next/static/image/public/assets/icons/trending-up.586c28e6184745874cf99beed08ccf0a.svg","height":24,"width":24};